import AccountInfo from './components/AccountInfo';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import get from 'lodash/get';

import {
  updateAgency,
  createAgency
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  return {
    isCreate:!(props.accountId && props.accountId.length > 0),
    accountId:props.accountId,
    name:get(state,['entities','agencies',props.accountId,'name'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({updateAgency,createAgency},dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountInfo));



// WEBPACK FOOTER //
// ./src/routes/AccountInfo/index.js